(function () {
	const button_els = document.querySelectorAll(`.archive-section-hero .btn-more, .archive-section-hero .btn-less`);
	if (button_els.length === 0) {
		return;
	}

	function on_click(e) {
		e.preventDefault();

		const button_el = e.currentTarget;

		button_el.closest(`.tab`).classList.toggle(`show-all`);
	}

	for (const button_el of button_els) {
		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const next_el = document.getElementById(`js-load-more`);
	if (!next_el) {
		return;
	}

	const content_el = document.querySelector(`.archive-grid, .person-grid, .jobs-grid`);
	if (!content_el) {
		return;
	}

	function on_click(e) {
		e.preventDefault();

		e.currentTarget.disabled = true;

		fetch(next_el.getAttribute(`href`))
			.then((response) => response.text())
			.then((response) => {
				const parser = new window.DOMParser(),
					doc = parser.parseFromString(response, `text/html`),
					entries = doc.querySelectorAll(`.archive-grid .snippet, .person-grid .snippet, .jobs-grid article`);

				if (entries.length === 0) {
					next_el.parentNode.parentNode.removeChild(next_el.parentNode);
					return;
				}

				for (let i = 0; i < entries.length; i++) {
					content_el.appendChild(entries[i]);
				}

				const next_pagination_el = doc.getElementById(`js-load-more`);
				if (next_pagination_el) {
					next_el.href = next_pagination_el.href;
				} else {
					next_el.parentNode.parentNode.removeChild(next_el.parentNode);
				}
			});
	}

	next_el.addEventListener(`click`, on_click);
})();
